import React, { useState, useEffect } from "react";
import { Box, Button, Select, MenuItem } from "@mui/material";
import { Route, Routes } from 'react-router-dom'
import { useNavigate } from "react-router";
import {useDispatch, useSelector} from "react-redux"
import { setUserInfo } from "../../redux/slice/user";
import api from "../../API";
import GroupIcon from '@mui/icons-material/Group';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import RuleIcon from '@mui/icons-material/Rule';
import { SearchBackDrop } from "../component/common/SearchBackDrop";
import SsbWorkerPage from "./SsbWorkerPage";
import PrcWorkerPage from "./PrcWorkerPage";
import IspWorkerPage from "./IspWorkerPage";
import IspMcqWorkerPage from "./IspMcqWorkerPage";
import IspMcqV2WorkerPage from "./IspMcqV2WorkerPage";
import IspEssWorkerPage from "./IspEssWorkerPage";
import IspSaqWorkerPage from "./IspSaqWorkerPage";


const SsbWorkerRouter = (props:any) => {

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  return (
    <Box>
      <Routes>
        {/* <Route path="/evkn-category" element={<EvknCategory />} /> 
        <Route path="/rsimpleqa" element={<EvknRSimpleQAPage />} /> 
        <Route path="/rhellaswag" element={<EvknRHellaSwagPage />} /> 
        <Route path="/rmmlu" element={<EvknRMMLUQAPage />} /> 
        <Route path="/simple" element={<EvknSimpleQAPage />} /> 
        <Route path="/prc-openbook" element={<EvknOpenBookPage />} /> 
        <Route path="/hellaswag" element={<EvknHellaSwagPage />} /> 
        <Route path="/mmlu" element={<EvknMMLUPage />} /> 
        
        <Route path="/bufsPage" element={<BufsWorkerPage />} />
        <Route path="/create-context" element={<EvltCreatePage />} /> 
        <Route path="/narrativeqa" element={<NarrativeQAPage />} /> 
        <Route path="/lfsum" element={<LFSumPage />} /> 
        <Route path="/mrcr" element={<MRCRQAPage />} /> 
        <Route path="/logiqa" element={<LogiQAPage />} /> 
        <Route path="/insertSentence" element={<EvltInsertSentencePage />} />
        <Route path="/idk" element={<EvltIdkPage />} />
        <Route path="/prc" element={<TzaWorkerPRCPage />} />
        <Route path="/isp" element={<TzaWorkerISPPage />} />
        <Route path="*" element={<EvalWorkerPage />} /> */}
        <Route path="/prc" element={<PrcWorkerPage />} />
        <Route path="/isp" element={<IspWorkerPage />} />
        <Route path="/isp-mcq" element={<IspMcqWorkerPage />} />
        <Route path="/isp-mcq-v2" element={<IspMcqV2WorkerPage />} />
        <Route path="/isp-ess" element={<IspEssWorkerPage />} />
        <Route path="/isp-saq" element={<IspSaqWorkerPage />} />
        <Route path="*" element={<SsbWorkerPage />} />
      </Routes>
    </Box>
  );
};

export default SsbWorkerRouter;
